window.$ = window.jQuery = require('jquery');
window.bootbox = require('bootbox');
window.moment = require('moment');
window.Noty = require('noty');
window.populate = require('populate.js');
window.JSZip = require('jszip');

/**
 * Libraries
 */
require('bootstrap');
require('metismenu');
require('jquery-stickytabs');
require('jquery.nicescroll');
require('jquery-slimscroll');
require('sortablejs');
require('jquery.steps');
require('trumbowyg');
require('bootstrap-datepicker');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.nl.min.js');
require('populate.js');
require('selectize');
require('spectrum-colorpicker2/dist/spectrum.min.js');
require('moment/locale/nl.js');

/**
 * Parsley
 */
require('parsleyjs');
require('parsleyjs/dist/i18n/nl.js');
require('parsleyjs/dist/i18n/nl.extra.js');

/**
 * Datatables
 */
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/dataTables.buttons.min.js');
require('datatables.net-buttons/js/buttons.colVis.min.js');
require('datatables.net-buttons/js/buttons.html5.min.js');
require('datatables.net-buttons/js/buttons.print.min.js');
require('datatables.net-responsive-bs4');
require('datatables.net-select-bs4');